var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBasicCurrency(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 13,
    fill: "#6867DD"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.5,
    stroke: "#6867DD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9451 21.2025C22.2659 21.5958 21.4079 21.3455 21.0147 20.7021L19.3702 17.8421V17.8064C19.4417 17.6991 19.5132 17.5919 19.5847 17.4489C20.0137 16.7339 20.264 15.8759 20.264 14.9465C20.264 14.1957 20.0852 13.445 19.7635 12.8015C19.692 12.6943 19.6562 12.5513 19.5847 12.444L19.7992 12.8015L23.5171 19.2363C23.8746 19.9513 23.6244 20.8093 22.9451 21.2025Z",
    fill: "url(#paint0_linear_19_164)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4822 11.4429C24.4822 12.2293 23.8388 12.8728 23.0523 12.8728H19.7276C19.6561 12.7656 19.6204 12.6226 19.5489 12.5153C18.7624 11.1211 17.2967 10.1559 15.6522 10.0487H23.0523C23.8388 10.0129 24.4822 10.6564 24.4822 11.4429Z",
    fill: "url(#paint1_linear_19_164)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9334 12.4797C10.5044 13.2304 10.2541 14.0526 10.2541 14.9821C10.2541 15.7328 10.4329 16.4836 10.7546 17.127C10.8261 17.2343 10.8619 17.3773 10.9334 17.4845L10.7189 17.127L7.00096 10.6922C6.60772 10.013 6.85797 9.155 7.5372 8.76177C8.21643 8.36853 9.07441 8.61878 9.46765 9.26226L11.1121 12.1222V12.1579C11.0764 12.2652 11.0049 12.3724 10.9334 12.4797Z",
    fill: "url(#paint2_linear_19_164)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.259 19.9512H7.42996C6.64348 19.9512 6 19.3077 6 18.5213C6 17.7348 6.64348 17.0913 7.42996 17.0913H10.7546C10.8261 17.1986 10.8619 17.3416 10.9334 17.4488C11.7198 18.843 13.1856 19.8082 14.83 19.9155C14.973 19.9512 15.116 19.9512 15.259 19.9512Z",
    fill: "url(#paint3_linear_19_164)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5488 17.4846L19.3343 17.842L15.6164 24.2769C15.2232 24.9561 14.3652 25.2064 13.686 24.8131C13.0068 24.4199 12.7923 23.5619 13.1498 22.8827L14.7942 20.0227C14.9372 20.0227 15.0445 20.0227 15.1875 20.0227C16.9034 20.0227 18.3691 19.1648 19.2986 17.8778C19.4058 17.699 19.4773 17.5918 19.5488 17.4846Z",
    fill: "url(#paint4_linear_19_164)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7634 12.8372C19.6919 12.7299 19.6561 12.5869 19.5847 12.4797C18.7982 11.0855 17.3325 10.1202 15.688 10.013L17.3682 7.11733C17.7614 6.4381 17.5112 5.58011 16.832 5.18688C16.1527 4.79364 15.2948 5.04388 14.9015 5.72311L11.1479 12.1222V12.1579C11.0764 12.2652 11.0049 12.3724 10.9334 12.5154C10.5044 13.2662 10.2542 14.0884 10.2542 15.0179C10.2542 15.7686 10.4329 16.5193 10.7546 17.1628C10.8261 17.2701 10.8619 17.413 10.9334 17.5203C11.7199 18.9145 13.1856 19.8797 14.83 19.987C14.973 19.987 15.0803 19.987 15.2233 19.987C16.9392 19.987 18.4049 19.129 19.3344 17.842C19.4059 17.7348 19.4774 17.6276 19.5489 17.4846C19.9779 16.7696 20.2281 15.9116 20.2281 14.9821C20.2281 14.2314 20.0494 13.4807 19.7634 12.8372ZM15.259 17.1271C14.0793 17.1271 13.1141 16.1618 13.1141 14.9821C13.1141 13.8024 14.0793 12.8372 15.259 12.8372C16.4387 12.8372 17.404 13.8024 17.404 14.9821C17.404 16.1618 16.4387 17.1271 15.259 17.1271Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19_164",
    x1: 22.9535,
    y1: 20.9802,
    x2: 16.0696,
    y2: 9.63705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_19_164",
    x1: 24.4397,
    y1: 11.4267,
    x2: 12.62,
    y2: 11.4267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_19_164",
    x1: 7.68842,
    y1: 8.9759,
    x2: 14.5229,
    y2: 20.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_19_164",
    x1: 6.28099,
    y1: 18.539,
    x2: 19.752,
    y2: 18.539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_19_164",
    x1: 13.7097,
    y1: 24.6853,
    x2: 20.7915,
    y2: 12.7988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasicCurrency);
export default __webpack_public_path__ + "static/media/basic_currency.6b46607e45c9c7ab1b7e70a002cb8e3a.svg";
export { ForwardRef as ReactComponent };